
      // This code is going to be bundled into the .js output by Vite,
      // but only in production.
      import init from '/src/viewer.ts'
      import pluginConfig from '/src/plugin-config.json' assert { type: 'json' }

      for (let pluginElement of document.querySelectorAll(
        `[data-plugin="${pluginConfig.name}-viewer"]`,
      )) {
        init(pluginElement, JSON.parse(pluginElement.dataset.options ?? '{}'))
      }
    